/**
 * Generated by orval v7.7.0 🍺
 * Do not edit manually.
 * RakeBack Wizard API
 * OpenAPI spec version: 1.0.0
 */
import { useMutation } from '@tanstack/react-query'
import type { MutationFunction, UseMutationOptions, UseMutationResult } from '@tanstack/react-query'

import type { GTOWizardRedemption, GTOWizardRedemptionResponse } from '../models'

import redemptionsRedemptionOptionsGtoWizardRedeemCreateMutator from '../../client'

/**
 * Redeem Edge points for a GTO Wizard subscription. Users with `first_subscription_discount_available = true` receive a 50% discount. The request requires a valid redemption option ID, the user's GTO Wizard email, and the expected price for validation. If the expected price doesn't match the current calculated price, the request will be rejected with an error suggesting to refresh the page. Upon successful redemption, a SubscriptionRedemption record is created for manual fulfillment tracking.
 * @summary Redeem GTO Wizard Subscription
 */
export const redemptionsRedemptionOptionsGtoWizardRedeemCreate = (
  gTOWizardRedemption: GTOWizardRedemption,
  signal?: AbortSignal,
) => {
  return redemptionsRedemptionOptionsGtoWizardRedeemCreateMutator<GTOWizardRedemptionResponse>({
    url: `/api/v1/redemptions/redemption-options/gto-wizard/redeem/`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: gTOWizardRedemption,
    signal,
  })
}

export const getRedemptionsRedemptionOptionsGtoWizardRedeemCreateMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof redemptionsRedemptionOptionsGtoWizardRedeemCreate>>,
    TError,
    { data: GTOWizardRedemption },
    TContext
  >
}): UseMutationOptions<
  Awaited<ReturnType<typeof redemptionsRedemptionOptionsGtoWizardRedeemCreate>>,
  TError,
  { data: GTOWizardRedemption },
  TContext
> => {
  const mutationKey = ['redemptionsRedemptionOptionsGtoWizardRedeemCreate']
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof redemptionsRedemptionOptionsGtoWizardRedeemCreate>>,
    { data: GTOWizardRedemption }
  > = (props) => {
    const { data } = props ?? {}

    return redemptionsRedemptionOptionsGtoWizardRedeemCreate(data)
  }

  return { mutationFn, ...mutationOptions }
}

export type RedemptionsRedemptionOptionsGtoWizardRedeemCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof redemptionsRedemptionOptionsGtoWizardRedeemCreate>>
>
export type RedemptionsRedemptionOptionsGtoWizardRedeemCreateMutationBody = GTOWizardRedemption
export type RedemptionsRedemptionOptionsGtoWizardRedeemCreateMutationError = void

/**
 * @summary Redeem GTO Wizard Subscription
 */
export const useRedemptionsRedemptionOptionsGtoWizardRedeemCreate = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof redemptionsRedemptionOptionsGtoWizardRedeemCreate>>,
    TError,
    { data: GTOWizardRedemption },
    TContext
  >
}): UseMutationResult<
  Awaited<ReturnType<typeof redemptionsRedemptionOptionsGtoWizardRedeemCreate>>,
  TError,
  { data: GTOWizardRedemption },
  TContext
> => {
  const mutationOptions =
    getRedemptionsRedemptionOptionsGtoWizardRedeemCreateMutationOptions(options)

  return useMutation(mutationOptions)
}
